import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import { routerTo, getDetailData } from './utils/utils'
import 'element-plus/dist/index.css'
import 'swiper/swiper-bundle.css'
import './assets/iconfont/iconfont.css';
import Tres from '@tresjs/core';

//引入国际化
import i18n from './i18n/index';

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
app.config.globalProperties.$routerTo = routerTo
app.config.globalProperties.$getDetailData = getDetailData

app.use(ElementPlus)
app.use(router)
app.use(i18n);
app.use(Tres);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.mount('#app')
